/** @format */

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { FilterChipsComponent } from '../filter-chips/filter-chips.component';
import { Store } from '@ngrx/store';
import { selectProductListSEOName } from '@plp/data-access/state';

@Component({
  selector: 'plp-components-no-filtered-results',
  imports: [FilterChipsComponent],
  templateUrl: './no-filtered-results.component.html',
  styleUrl: './no-filtered-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoFilteredResultsComponent {
  private readonly store = inject(Store);
  categoryName = this.store.selectSignal(selectProductListSEOName);
}
